"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRequestAnimationFrame = void 0;
var _web = require("@react-hookz/web");
var _react = require("react");
const useRequestAnimationFrame = () => {
  const rafIdRef = (0, _react.useRef)(0);
  const cancel = (0, _react.useCallback)(() => {
    cancelAnimationFrame(rafIdRef.current);
  }, []);
  const isMounted = (0, _web.useIsMounted)();
  const raf = (0, _react.useCallback)(callback => {
    cancel();
    rafIdRef.current = requestAnimationFrame(() => {
      if (isMounted()) {
        callback();
      }
    });
  }, [isMounted, cancel]);
  (0, _web.useUnmountEffect)(cancel);
  return {
    cancel,
    raf
  };
};
exports.useRequestAnimationFrame = useRequestAnimationFrame;
//# sourceMappingURL=useRequestAnimationFrame.js.map